import { makeVar } from '@apollo/client'

export const shouldDisableActionBtnsVar = makeVar<boolean>(false)

export const getShouldDisableActionBtns = (): boolean => {
  return shouldDisableActionBtnsVar()
}

export const setShouldDisableActionBtns = (value: boolean): void => {
  shouldDisableActionBtnsVar(value)
}
